export const BORDER = 4
export const IMAGE_RATIO = 16 / 9
export const IMAGE_MARGIN = 64
export const IMAGE_WIDTH = 300
